var arrow = function arrow(_ref) {
  var bgColor = _ref.bgColor,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      size = _ref.size;
  return "\n  &::after,\n  &::before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &::after {\n    border-bottom-color: ".concat(bgColor, ";\n    border-width: ").concat(size - borderWidth, "px;\n    margin-left: -").concat(size - borderWidth, "px;\n  }\n\n  &::before {\n    border-bottom-color: ").concat(borderColor, ";\n    border-width: ").concat(size, "px;\n    margin-left: -").concat(size, "px;\n  }\n");
};

export default arrow;